import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b64e1e1")

_pushScopeId("data-v-5b64e1e1")
const _hoisted_1 = { class: "contact-box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "hint" }, "（接受预定通知）", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: _ctx.information,
      rules: _ctx.rules,
      "label-position": "left",
      "label-width": "85px",
      ref: "form"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          label: "联系人姓名",
          prop: "name"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.information.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.information.name = $event)),
              type: "text",
              name: "name"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "手机号",
          prop: "phoneNumber"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.information.phoneNumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.information.phoneNumber = $event)),
              type: "text",
              name: "phoneNumber"
            }, null, 8, ["modelValue"]),
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
})